var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"btn btn-label btn-primary float-right",attrs:{"disabled":_vm.isPDFDisabled,"id":"btn_search","variant":"primary"},on:{"click":_vm.pdfgen}},[_c('i',{staticClass:"bx bxs-file-pdf label-icon"}),_vm._v("Download PDF")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }